import { render, staticRenderFns } from "./GlobalOnboardingFlow.vue?vue&type=template&id=30027192"
import script from "./GlobalOnboardingFlow.vue?vue&type=script&lang=js"
export * from "./GlobalOnboardingFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports